module.exports = __webpack_public_path__ + "img/bootstrap.89cb0c14.svg";